<template>
    <div>
        <div class = "menu_div">
            <h3 class="text-center">{{this.EventBus.getText("menu_title")}}</h3>
            <div class="containers">
                <div class="item" v-for="data in datas" v-bind:key="data.index">
                    <div class="pointer" @click="links(data.path)">
                        <a class="hvr-grow">
                        <img :src=data.img alt="">
                        <p>{{data.subject}}</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        
    <Footer/>
    <js/>
    </div>
</template>

<script>
import Menu from '../assets/language/menu.json'
export default {
    beforeCreate(){
        this.EventBus.loadLanguage(Menu);
    },
    data() {
        return {
            datas: [
                {
                    index: 1,
                    img: '/static/tutorial/2. 편집/17. 길이조절.png',
                    subject:this.EventBus.getText("menu_edit"),
                    path: '/menu/edit',
                },
                {
                    index: 2,
                    img: '/static/tutorial/3. 도구/8. 스냅.png',
                    subject:this.EventBus.getText("menu_tool"),
                    path: '/menu/tool',
                },
                {
                    index: 3,
                    img: '/static/tutorial/4. 보기/1. 색 칠하기.png',
                    subject:this.EventBus.getText("menu_view"),
                    path: '/menu/look',
                },
                {
                    index: 4,
                    img: '/static/tutorial/5. 고급/3. 맞물리는 톱니.png',
                    subject:this.EventBus.getText("menu_advanced"),
                    path: '/menu/advanced',
                },
                {
                    index: 5,
                    img: '/static/tutorial/6. 설정/1. 환경설정.png',
                    subject:this.EventBus.getText("menu_setting"),
                    path: '/menu/setting',
                },
            ]
        }
    },
    methods:{
        links(path){
            window.location.href = path
        }
    }
}
</script>

<style scoped>
    .menu_div{
        padding: 2vh 0;
        text-align: center;
        width: 50%;
        margin: 8vh auto;
    }
    .containers{
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        /* align-content: space-between; */
        align-items: center;
        padding-left: 3vw;
        /* justify-content: center; */
           }
    .item{
        width: 250px;
        height: 200px;
        border-radius: 10px;
        background-color:#FBFBFB;
        padding: 25px;
        margin: 1.5vh 0.5vw;
        box-shadow: 0px 0px 5px 3px rgba(0,0,0,0.1);
        /* text-align: center; */
    }
    h3 {
        font-size: 1.6rem;
        margin: 10vh 0;
    }
    img {
        width: 60px;
        margin: 20px 0px;
    }
    p{
        font-weight: 700;
        color: black;
    }
    .pointer       { cursor: pointer; }
    .hvr-grow {
        margin: 7px;
        display: inline-block;
        vertical-align: middle;
        -webkit-transform: perspective(1px) translateZ(0);
        transform: perspective(1px) translateZ(0);
        box-shadow: 0 0 1px rgba(0, 0, 0, 0);
        -webkit-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -webkit-transition-property: transform;
        transition-property: transform;
        }
        .hvr-grow:hover, .hvr-grow:focus, .hvr-grow:active {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
        }
</style>


// WEBPACK FOOTER //
// src/pages/menu.vue